export default [
    {
        id: 0,
        name: '系统图库',
        type: [
            {
                id0: 0, name: '灯', showPicture: false,
                pictureList: [
                    {
                        type: "img",
                        name: '灯-1',
                        url: '/static/picture/systemPicture/01灯/灯1.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '灯-2',
                        url: '/static/picture/systemPicture/01灯/灯2.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '灯-3',
                        url: '/static/picture/systemPicture/01灯/灯3.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '灯-4',
                        url: '/static/picture/systemPicture/01灯/灯4.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '灯-5',
                        url: '/static/picture/systemPicture/01灯/灯5.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },

                ]
            },
            {
                id0: 1, name: '泵', showPicture: false,
                pictureList: [
                    {
                        type: "img",
                        name: '泵-1',
                        url: '/static/picture/systemPicture/02泵/泵1.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '泵-2',
                        url: '/static/picture/systemPicture/02泵/泵2.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '泵-3',
                        url: '/static/picture/systemPicture/02泵/泵3.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '泵-4',
                        url: '/static/picture/systemPicture/02泵/泵4.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '泵-5',
                        url: '/static/picture/systemPicture/02泵/泵5.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '泵-6',
                        url: '/static/picture/systemPicture/02泵/泵6.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '泵-7',
                        url: '/static/picture/systemPicture/02泵/泵7.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '泵-8 ',
                        url: '/static/picture/systemPicture/02泵/泵8.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '泵-9 ',
                        url: '/static/picture/systemPicture/02泵/泵9.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '泵-10 ',
                        url: '/static/picture/systemPicture/02泵/泵10.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '泵-11 ',
                        url: '/static/picture/systemPicture/02泵/泵11.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '泵-12 ',
                        url: '/static/picture/systemPicture/02泵/泵12.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '泵-13 ',
                        url: '/static/picture/systemPicture/02泵/泵13.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '泵-14 ',
                        url: '/static/picture/systemPicture/02泵/泵14.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '泵-15 ',
                        url: '/static/picture/systemPicture/02泵/泵15.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '泵-16 ',
                        url: '/static/picture/systemPicture/02泵/泵16.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '泵-17 ',
                        url: '/static/picture/systemPicture/02泵/泵17.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '泵-18 ',
                        url: '/static/picture/systemPicture/02泵/泵18.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '泵-18 ',
                        url: '/static/picture/systemPicture/02泵/泵18.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '泵-19 ',
                        url: '/static/picture/systemPicture/02泵/泵19.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '泵-20 ',
                        url: '/static/picture/systemPicture/02泵/泵20.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '泵-21 ',
                        url: '/static/picture/systemPicture/02泵/泵21.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '泵-22 ',
                        url: '/static/picture/systemPicture/02泵/泵22.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '泵-23 ',
                        url: '/static/picture/systemPicture/02泵/泵23.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '泵-24 ',
                        url: '/static/picture/systemPicture/02泵/泵24.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '泵-25 ',
                        url: '/static/picture/systemPicture/02泵/泵25.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '泵-26 ',
                        url: '/static/picture/systemPicture/02泵/泵26.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '泵-27 ',
                        url: '/static/picture/systemPicture/02泵/泵27.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '泵-28 ',
                        url: '/static/picture/systemPicture/02泵/泵28.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '泵-29 ',
                        url: '/static/picture/systemPicture/02泵/泵29.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '泵-30 ',
                        url: '/static/picture/systemPicture/02泵/泵30.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '泵-31 ',
                        url: '/static/picture/systemPicture/02泵/泵31.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '泵-32 ',
                        url: '/static/picture/systemPicture/02泵/泵32.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '泵-33 ',
                        url: '/static/picture/systemPicture/02泵/泵33.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '泵-34 ',
                        url: '/static/picture/systemPicture/02泵/泵34.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '泵-35 ',
                        url: '/static/picture/systemPicture/02泵/泵35.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '泵-36 ',
                        url: '/static/picture/systemPicture/02泵/泵36.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '泵-37 ',
                        url: '/static/picture/systemPicture/02泵/泵37.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '泵-38 ',
                        url: '/static/picture/systemPicture/02泵/泵38.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '泵-39 ',
                        url: '/static/picture/systemPicture/02泵/泵39.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '泵-40 ',
                        url: '/static/picture/systemPicture/02泵/泵40.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '泵-41 ',
                        url: '/static/picture/systemPicture/02泵/泵41.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '泵-42 ',
                        url: '/static/picture/systemPicture/02泵/泵42.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '泵-43 ',
                        url: '/static/picture/systemPicture/02泵/泵43.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    }
                ],
            },
            {
                id0: 2, name: '阀', showPicture: false,
                pictureList: [
                    {
                        type: "img",
                        name: '阀-1',
                        url: '/static/picture/systemPicture/03阀/阀1.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '阀-2',
                        url: '/static/picture/systemPicture/03阀/阀2.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '阀-3',
                        url: '/static/picture/systemPicture/03阀/阀3.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '阀-4',
                        url: '/static/picture/systemPicture/03阀/阀4.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '阀-5',
                        url: '/static/picture/systemPicture/03阀/阀5.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '阀-6',
                        url: '/static/picture/systemPicture/03阀/阀6.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '阀-7',
                        url: '/static/picture/systemPicture/03阀/阀7.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '阀-8',
                        url: '/static/picture/systemPicture/03阀/阀8.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },

                ]
            },
            {
                id0: 3, name: '管道', showPicture: false,
                pictureList: [
                    {
                        type: "img",
                        name: '管道-1',
                        url: '/static/picture/systemPicture/04管道/封头1.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '管道-2',
                        url: '/static/picture/systemPicture/04管道/封头2.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '管道-3',
                        url: '/static/picture/systemPicture/04管道/封头3.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '管道-4',
                        url: '/static/picture/systemPicture/04管道/封头4.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '管道-5',
                        url: '/static/picture/systemPicture/04管道/三通1.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '管道-6',
                        url: '/static/picture/systemPicture/04管道/三通2.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '管道-7',
                        url: '/static/picture/systemPicture/04管道/三通3.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '管道-8',
                        url: '/static/picture/systemPicture/04管道/三通4.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '管道-9',
                        url: '/static/picture/systemPicture/04管道/四通.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '管道-10',
                        url: '/static/picture/systemPicture/04管道/直管道1.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '管道-11',
                        url: '/static/picture/systemPicture/04管道/直管道2.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '管道-12',
                        url: '/static/picture/systemPicture/04管道/直角1.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '管道-13',
                        url: '/static/picture/systemPicture/04管道/直角2.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '管道-14',
                        url: '/static/picture/systemPicture/04管道/直角3.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '管道-15',
                        url: '/static/picture/systemPicture/04管道/直角4.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },

                ]
            },
            {
                id0: 4, name: '罐体', showPicture: false,
                pictureList: [
                    {
                        type: "img",
                        name: '罐体-1',
                        url: '/static/picture/systemPicture/05罐体/罐体1.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '罐体-2',
                        url: '/static/picture/systemPicture/05罐体/罐体2.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '罐体-3',
                        url: '/static/picture/systemPicture/05罐体/罐体3.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '罐体-4',
                        url: '/static/picture/systemPicture/05罐体/罐体4.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '罐体-5',
                        url: '/static/picture/systemPicture/05罐体/罐体5.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '罐体-6',
                        url: '/static/picture/systemPicture/05罐体/罐体6.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '罐体-7',
                        url: '/static/picture/systemPicture/05罐体/罐体7.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '罐体-8',
                        url: '/static/picture/systemPicture/05罐体/罐体8.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '罐体-9',
                        url: '/static/picture/systemPicture/05罐体/罐体9.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '罐体-10',
                        url: '/static/picture/systemPicture/05罐体/罐体10.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '罐体-11',
                        url: '/static/picture/systemPicture/05罐体/罐体11.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '罐体-12',
                        url: '/static/picture/systemPicture/05罐体/罐体12.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '罐体-13',
                        url: '/static/picture/systemPicture/05罐体/罐体13.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '罐体-14',
                        url: '/static/picture/systemPicture/05罐体/罐体14.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '罐体-15',
                        url: '/static/picture/systemPicture/05罐体/罐体15.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '罐体-16',
                        url: '/static/picture/systemPicture/05罐体/罐体16.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '罐体-17',
                        url: '/static/picture/systemPicture/05罐体/A01.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '罐体-17',
                        url: '/static/picture/systemPicture/05罐体/A01.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '罐体-18',
                        url: '/static/picture/systemPicture/05罐体/A02.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '罐体-19',
                        url: '/static/picture/systemPicture/05罐体/A03.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '罐体-20',
                        url: '/static/picture/systemPicture/05罐体/A04.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '罐体-21',
                        url: '/static/picture/systemPicture/05罐体/A05.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '罐体-22',
                        url: '/static/picture/systemPicture/05罐体/A06.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '罐体-23',
                        url: '/static/picture/systemPicture/05罐体/A07.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '罐体-24',
                        url: '/static/picture/systemPicture/05罐体/A08.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '罐体-25',
                        url: '/static/picture/systemPicture/05罐体/A09.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '罐体-26',
                        url: '/static/picture/systemPicture/05罐体/A10.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '罐体-27',
                        url: '/static/picture/systemPicture/05罐体/A11.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '罐体-28',
                        url: '/static/picture/systemPicture/05罐体/A12.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '罐体-29',
                        url: '/static/picture/systemPicture/05罐体/A13.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '罐体-30',
                        url: '/static/picture/systemPicture/05罐体/A14.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '罐体-31',
                        url: '/static/picture/systemPicture/05罐体/A15.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '罐体-32',
                        url: '/static/picture/systemPicture/05罐体/A16.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '罐体-33',
                        url: '/static/picture/systemPicture/05罐体/A17.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '罐体-34',
                        url: '/static/picture/systemPicture/05罐体/A18.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '罐体-35',
                        url: '/static/picture/systemPicture/05罐体/A19.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '罐体-36',
                        url: '/static/picture/systemPicture/05罐体/A20.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '罐体-37',
                        url: '/static/picture/systemPicture/05罐体/A21.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '罐体-38',
                        url: '/static/picture/systemPicture/05罐体/A22.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '罐体-39',
                        url: '/static/picture/systemPicture/05罐体/A23.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '罐体-40',
                        url: '/static/picture/systemPicture/05罐体/A24.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '罐体-41',
                        url: '/static/picture/systemPicture/05罐体/A25.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '罐体-42',
                        url: '/static/picture/systemPicture/05罐体/A26.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '罐体-43',
                        url: '/static/picture/systemPicture/05罐体/A27.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    }
                ]
            },
            {
                id0: 5, name: '锅炉', showPicture: false,
                pictureList: [
                    {
                        type: "img",
                        name: '锅炉-1',
                        url: '/static/picture/systemPicture/06锅炉/锅炉1.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '锅炉-2',
                        url: '/static/picture/systemPicture/06锅炉/锅炉2.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '锅炉-3',
                        url: '/static/picture/systemPicture/06锅炉/锅炉3.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '锅炉-4',
                        url: '/static/picture/systemPicture/06锅炉/锅炉4.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '锅炉-5',
                        url: '/static/picture/systemPicture/06锅炉/锅炉5.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },

                ]
            },
            {
                id0: 6, name: '传感器', showPicture: false,
                pictureList: [
                    {
                        type: "img",
                        name: '传感器-1',
                        url: '/static/picture/systemPicture/07传感器/传感器1.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '传感器-2',
                        url: '/static/picture/systemPicture/07传感器/传感器2.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '传感器-3',
                        url: '/static/picture/systemPicture/07传感器/传感器3.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '传感器-4',
                        url: '/static/picture/systemPicture/07传感器/传感器4.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '传感器-5',
                        url: '/static/picture/systemPicture/07传感器/传感器5.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '传感器-6',
                        url: '/static/picture/systemPicture/07传感器/传感器6.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '传感器-7',
                        url: '/static/picture/systemPicture/07传感器/传感器7.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '传感器-8',
                        url: '/static/picture/systemPicture/07传感器/传感器8.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                ],
            },
            {
                id0: 7, name: '流量计', showPicture: false,
                pictureList: [
                    {
                        type: "img",
                        name: '流量计-1',
                        url: '/static/picture/systemPicture/08流量计/流量计1.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '流量计-2',
                        url: '/static/picture/systemPicture/08流量计/流量计2.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '流量计-3',
                        url: '/static/picture/systemPicture/08流量计/流量计3.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '流量计-4',
                        url: '/static/picture/systemPicture/08流量计/流量计4.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '流量计-5',
                        url: '/static/picture/systemPicture/08流量计/流量计5.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '流量计-6',
                        url: '/static/picture/systemPicture/08流量计/流量计6.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '流量计-7',
                        url: '/static/picture/systemPicture/08流量计/流量计7.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },

                ]
            },
            {
                id0: 8, name: '搅拌', showPicture: false,
                pictureList: [
                    {
                        type: "img",
                        name: '搅拌-1',
                        url: '/static/picture/systemPicture/09搅拌/搅拌1.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '搅拌-2',
                        url: '/static/picture/systemPicture/09搅拌/搅拌2.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '搅拌-3',
                        url: '/static/picture/systemPicture/09搅拌/搅拌3.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '搅拌-4',
                        url: '/static/picture/systemPicture/09搅拌/搅拌4.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },

                ]
            },
            {
                id0: 9, name: '自然', showPicture: false,
                pictureList: [
                    {
                        type: "img",
                        name: '自然-1',
                        url: '/static/picture/systemPicture/12自然/黄花.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '自然-2',
                        url: '/static/picture/systemPicture/12自然/火焰1.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '自然-3',
                        url: '/static/picture/systemPicture/12自然/火焰2.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '自然-4',
                        url: '/static/picture/systemPicture/12自然/火焰3.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '自然-5',
                        url: '/static/picture/systemPicture/12自然/火焰4.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '自然-6',
                        url: '/static/picture/systemPicture/12自然/火焰5.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '自然-7',
                        url: '/static/picture/systemPicture/12自然/火焰6.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '自然-8',
                        url: '/static/picture/systemPicture/12自然/蓝火1.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '自然-9',
                        url: '/static/picture/systemPicture/12自然/蓝火2.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '自然-10',
                        url: '/static/picture/systemPicture/12自然/树木1.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '自然-11',
                        url: '/static/picture/systemPicture/12自然/树木2.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '自然-12',
                        url: '/static/picture/systemPicture/12自然/树木3.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '自然-13',
                        url: '/static/picture/systemPicture/12自然/001.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '自然-14',
                        url: '/static/picture/systemPicture/12自然/002.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '自然-15',
                        url: '/static/picture/systemPicture/12自然/003.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '自然-16',
                        url: '/static/picture/systemPicture/12自然/004.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '自然-17',
                        url: '/static/picture/systemPicture/12自然/005.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '自然-18',
                        url: '/static/picture/systemPicture/12自然/006.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '自然-19',
                        url: '/static/picture/systemPicture/12自然/007.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '自然-20',
                        url: '/static/picture/systemPicture/12自然/008.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '自然-21',
                        url: '/static/picture/systemPicture/12自然/009.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '自然-22',
                        url: '/static/picture/systemPicture/12自然/010.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '自然-23',
                        url: '/static/picture/systemPicture/12自然/011.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '自然-24',
                        url: '/static/picture/systemPicture/12自然/012.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '自然-25',
                        url: '/static/picture/systemPicture/12自然/013.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '自然-26',
                        url: '/static/picture/systemPicture/12自然/014.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '自然-27',
                        url: '/static/picture/systemPicture/12自然/015.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '自然-28',
                        url: '/static/picture/systemPicture/12自然/016.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '自然-29',
                        url: '/static/picture/systemPicture/12自然/017.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '自然-30',
                        url: '/static/picture/systemPicture/12自然/018.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '自然-31',
                        url: '/static/picture/systemPicture/12自然/019.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '自然-32',
                        url: '/static/picture/systemPicture/12自然/020.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '自然-33',
                        url: '/static/picture/systemPicture/12自然/021.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '自然-34',
                        url: '/static/picture/systemPicture/12自然/022.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '自然-35',
                        url: '/static/picture/systemPicture/12自然/023.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '自然-36',
                        url: '/static/picture/systemPicture/12自然/024.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '自然-37',
                        url: '/static/picture/systemPicture/12自然/025.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '自然-38',
                        url: '/static/picture/systemPicture/12自然/026.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '自然-39',
                        url: '/static/picture/systemPicture/12自然/027.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '自然-40',
                        url: '/static/picture/systemPicture/12自然/028.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '自然-41',
                        url: '/static/picture/systemPicture/12自然/029.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '自然-42',
                        url: '/static/picture/systemPicture/12自然/030.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                ]
            },
            {
                id0: 10, name: '按钮', showPicture: false,
                pictureList: [
                    {
                        type: "img",
                        name: '按钮-1',
                        url: '/static/picture/systemPicture/10按钮/01.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '按钮-2',
                        url: '/static/picture/systemPicture/10按钮/02.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '按钮-3',
                        url: '/static/picture/systemPicture/10按钮/03.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '按钮-4',
                        url: '/static/picture/systemPicture/10按钮/04.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '按钮-5',
                        url: '/static/picture/systemPicture/10按钮/05.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '按钮-6',
                        url: '/static/picture/systemPicture/10按钮/06.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '按钮-7',
                        url: '/static/picture/systemPicture/10按钮/07.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '按钮-8',
                        url: '/static/picture/systemPicture/10按钮/08.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '按钮-9',
                        url: '/static/picture/systemPicture/10按钮/09.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '按钮-10',
                        url: '/static/picture/systemPicture/10按钮/10.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '按钮-11',
                        url: '/static/picture/systemPicture/10按钮/11.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '按钮-12',
                        url: '/static/picture/systemPicture/10按钮/12.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '按钮-13',
                        url: '/static/picture/systemPicture/10按钮/13.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '按钮-14',
                        url: '/static/picture/systemPicture/10按钮/14.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '按钮-15',
                        url: '/static/picture/systemPicture/10按钮/15.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '按钮-16',
                        url: '/static/picture/systemPicture/10按钮/16.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    }
                ]
            },
            {
                id0:11, name: '风机', showPicture: false,
                pictureList: [
                    {
                        type: "img",
                        name: '风机-1',
                        url: '/static/picture/systemPicture/11风机/F01.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '风机-2',
                        url: '/static/picture/systemPicture/11风机/F02.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '风机-3',
                        url: '/static/picture/systemPicture/11风机/F03.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '风机-4',
                        url: '/static/picture/systemPicture/11风机/F04.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '风机-5',
                        url: '/static/picture/systemPicture/11风机/F05.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '风机-6',
                        url: '/static/picture/systemPicture/11风机/F06.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '风机-7',
                        url: '/static/picture/systemPicture/11风机/F07.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '风机-8',
                        url: '/static/picture/systemPicture/11风机/F08.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '风机-9',
                        url: '/static/picture/systemPicture/11风机/F09.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '风机-10',
                        url: '/static/picture/systemPicture/11风机/F10.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '风机-11',
                        url: '/static/picture/systemPicture/11风机/L01.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '风机-12',
                        url: '/static/picture/systemPicture/11风机/L02.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '风机-13',
                        url: '/static/picture/systemPicture/11风机/L03.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '风机-14',
                        url: '/static/picture/systemPicture/11风机/L04.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '风机-15',
                        url: '/static/picture/systemPicture/11风机/L05.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '风机-16',
                        url: '/static/picture/systemPicture/11风机/L06.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '风机-17',
                        url: '/static/picture/systemPicture/11风机/L07.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '风机-18',
                        url: '/static/picture/systemPicture/11风机/L08.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '风机-19',
                        url: '/static/picture/systemPicture/11风机/L09.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    },
                    {
                        type: "img",
                        name: '风机-20',
                        url: '/static/picture/systemPicture/11风机/L10.png',
                        wrapperStyle: {
                            width: '100px',
                            height: '100px',
                        },
                        style: {
                            'transform': 'rotate(0deg)', width: '100px', height: '100px',

                        },
                        settings: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        realtimeData: {
                            width: '100',
                            height: '100',
                            imgName: '图片',
                            imgDirection: 0, state: true,
                        },
                        events: [],
                        variableEvents: [],
                    }
                ]
            },

        ],
        showContent: false,
    },
]